export default __webpack_public_path__ + "static/media/JumbotronPicture.ec3f0c38.jpg";